import React, { useContext } from 'react';

import { Step } from '../types';

import { StepContext } from '../contexts/stepContext';
import CodeForm from './Forms/CodeForm';
import InitialForm from './Forms/InitialForm';
import PasswordForm from './Forms/PasswordForm';
import PasswordChanged from './PasswordChanged';

export const StepContent = (): JSX.Element => {
  const { activeStep } = useContext(StepContext);

  switch (activeStep) {
    case Step.INITIAL:
      return <InitialForm />;
    case Step.CODE:
      return <CodeForm />;
    case Step.PASSWORD:
      return <PasswordForm />;
    case Step.DONE:
      return <PasswordChanged />;
    default:
      console.error('Default step: wrong data type!');
      return (
        <InitialForm />
      );
  }
};
